export const constants = {
  COUNTDOWN_STARTED: "COUNTDOWN_STARTED",
  COUNTDOWN_STOPPED: "COUNTDOWN_STOPPED",
  MULTIPLIER_STARTED: "MULTIPLIER_STARTED",
  MULTIPLIER_STOPPED: "MULTIPLIER_STOPPED",
};
